<template>
  <div v-if="dataPermission.includes('CNPS_DEVICE_CATEGORY_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh mục thiết bị</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          @click="$router.push('/add-cat-device')"
          v-if="dataPermission.includes('CNPS_DEVICE_CATEGORY_CREATE')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
        <button @click="exportExcel" class="font-medium f12 btn btn-outline-secondary">
          <i class="bx bx-download"></i> Xuất excel
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transfromDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2 v-model="search.service" :options="optionService" placeholder="Dịch vụ">
            </Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.type" :options="optionType" placeholder="Loại thiết bị">
            </Select2>
          </div>
          <div class="form-group">
            <input v-model.trim="search.name" placeholder="Tên thiết bị" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.status" :options="optionStatus" placeholder="Trạng thái">
            </Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <span><b>Tổng danh mục</b>: {{ pagination.total }}</span>
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataCat"
              :fields="filterTable"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(type)="data">
                {{ data.item.type | transformData(optionType) }}
              </template>
              <template #cell(price)="data">
                <span v-if="data.item.price > 0">
                  {{ data.item.price | transformMoney }}
                </span>
                <span v-else>{{ data.item.price }}</span>
              </template>
              <template #cell(unit)="data">
                {{ data.item.unit | transformData(optionUnit) }}
              </template>
              <template #cell(serial)="data">
                {{ data.item.kind | transformData(Config.checkSerial) }}
              </template>
              <template #cell(services)="data">
                {{ data.item.services.toString() }}
              </template>
              <template #cell(userCreator)="data">
                {{ data.item.userCreator.name }} <br />
                <p class="text-primary">{{ data.item.userCreator.email }}</p>
              </template>
              <template #cell(time)="data">
                <p><b>Tạo</b>: {{ data.item.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}</p>
                <br />
                <p v-if="data.item.dateModified != 0">
                  <b>Cập nhật</b>:
                  {{ data.item.dateModified | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(status)="data">
                <b-badge
                  class="font-size-12"
                  pill
                  :variant="data.item.status == 'ACTIVE' ? 'primary' : 'danger'"
                  size="sm"
                >
                  {{ data.item.status | transformData(optionStatus) }}
                </b-badge>
              </template>
              <template #cell(action)="data">
                <b-dropdown id="dropdown-1" class="m-md-2" variant="outline-light">
                  <b-dropdown-item @click="toDetail(data.item)"> Chi tiết </b-dropdown-item>
                  <b-dropdown-item
                    @click="$router.push({ path: `/cat-device/edit/${data.item.id}` })"
                    v-if="
                      data.item.status == 'ACTIVE' &&
                      dataPermission.includes('CNPS_DEVICE_CATEGORY_UPDATE')
                    "
                    >Sửa
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="LocknUnlock(data.item)"
                    v-if="
                      data.item.status == 'ACTIVE' &&
                      dataPermission.includes('CNPS_DEVICE_CATEGORY_UPDATE')
                    "
                    >Khoá
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="LocknUnlock(data.item)"
                    v-if="
                      data.item.status != 'ACTIVE' &&
                      dataPermission.includes('CNPS_DEVICE_CATEGORY_UPDATE')
                    "
                    >Mở khoá
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          class="mr-2 fl-right"
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
        ></b-pagination>
      </div>
    </div>

    <!-- Modal xác nhận mở khoá/ khoá-->
    <b-modal id="modal-scoped" v-model="lockModal">
      <template #modal-header="{ close }">
        <h5 v-if="stateGr.status == 'ACTIVE'">Khoá danh mục thiết bị</h5>
        <h5 v-else>Mở khoá danh mục thiết bị</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <h2 class="py-3 f18" v-if="stateGr.status == 'ACTIVE'">
          Bạn muốn khoá danh mục thiết bị này ?
        </h2>
        <h2 class="py-3 f18" v-else>Bạn muốn mở khoá danh mục thiết bị này ?</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
        <b-button variant="primary" @click="cancel(), confirmLocknActive()"> Xác nhận </b-button>
      </template>
    </b-modal>
    <!-- Modal thông báo -->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from 'moment'
  import Config from '@/thirdParty/config'
  import { SalesManagerService } from '@/services/sales-manager.service'
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'type', label: 'Loại thiết bị' },
    { key: 'name', label: 'Tên thiết bị' },
    { key: 'nickname', label: 'Tên rút gọn' },
    { key: 'abbreviation', label: 'Tên viết tắt' },
    { key: 'price', label: 'Giá bán (VNĐ)', class: 'text-center' },
    { key: 'warrantyPeriod', label: 'Thời hạn bảo hành', class: 'text-center' },
    { key: 'unit', label: 'Đơn vị' },
    { key: 'serial', label: 'Quản lý serial' },
    { key: 'services', label: 'Dịch vụ sử dụng' },
    { key: 'userCreator', label: 'Người tạo' },
    { key: 'time', label: 'Thời gian' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    components: {
      DateRangePicker,
    },
    mixins: [prepareQueryParamsMixin],
    computed: {
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    data() {
      return {
        loading: false,
        showLoading: false,
        search: {
          page: 1,
          limit: 20,
        },
        pagination: {
          total: 0,
        },
        fieldsTable,
        filterTable: fieldsTable,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        localeData: Config.localeData,
        optionService: [],
        optionType: [{ id: 0, text: 'Tất cả' }, ...Config.typeDevice],
        optionStatus: [{ id: 0, text: 'Tất cả' }, ...Config.statusCatDevice],
        dataCat: [],
        optionUnit: Config.unitDevice,
        lockModal: false,
        stateGr: {},
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        Config,
      }
    },
    created() {
      this.getListService()
      this.fetchData()
    },
    methods: {
      LocknUnlock(item) {
        this.stateGr = item
        this.lockModal = true
      },
      async confirmLocknActive() {
        try {
          const data = await DeviceService.changeStateCat({
            id: this.stateGr.id,
            status: this.stateGr.status === 'ACTIVE' ? 'LOCKED' : 'ACTIVE',
          })
          if (data.success) {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Thao tác thành công'
            this.fetchData()
          }
        } catch (error) {
          console.log(error)
        }
      },
      toDetail(item) {
        window.open(`/cat-device/${item.id}`, '_blank')
      },
      transfromDate() {
        this.search.dateFrom = moment(this.dateRange.startDate).startOf('day').valueOf()
        this.search.dateTo = moment(this.dateRange.endDate).endOf('day').valueOf()
      },
      async getListService() {
        try {
          const data = await SalesManagerService.getGroupService({})
          if (data.success) {
            this.optionService = data.data.groupService
              .map(e => e.detail)
              .flat()
              .map(el => {
                return {
                  id: el.code,
                  text: el.name,
                }
              })
            this.optionService.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async fetchData() {
        try {
          if (this.search.service === 0) delete this.search.service
          if (this.search.type === 0) delete this.search.type
          if (this.search.status === 0) delete this.search.status
          this.loading = true
          const data = await DeviceService.listCatDevice(this.search)
          if (data.success) {
            this.dataCat = data.data.categoryList
            this.pagination.total = data.data.count ? data.data.count : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()
      },
      // Bỏ lọc
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },
      async exportExcel() {
        try {
          this.showLoading = true
          const req = { ...this.search }
          delete req.page
          delete req.limit
          await DeviceService.exportCatDevice(req)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style></style>
